/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from "@sentry/react";

const initializeSentry = () => {
  if (import.meta.env.DEV) {
    return;
  }

  Sentry.init({
    environment: import.meta.env.MODE,
    release: process.env.PACKAGE_VERSION,
    dsn: "https://aec31bd235de54314526d65d45a859af@o460330.ingest.us.sentry.io/4509443193700352",
    tracesSampleRate: import.meta.env.MODE ? 1 : 0.1,
  });
};

export const sentryCaptureException = (error: unknown, options: { tags?: Record<string, string>; context?: Record<string, string> }) => {
  const { tags = {}, context = {} } = options;

  Sentry.withScope((scope: any) => {
    Object.entries(tags).forEach(([key, value]) => {
      scope.setTag(key, value);
    });

    Object.entries(context).forEach(([key, val]) => {
      scope.setContext(key, val);
    });

    Sentry.captureException(error);
  });
};

export default initializeSentry;
